import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header";
import Loader from "../../Utils/Loader";
import Select from "react-select";
import {
  customStyles,
  handleGetApiGF,
  shareIphonePostMsg,
  Toast,
} from "../../Utils/general-function";
import Innerlistcommon from "./Innerlistcommon";
import { Shareurl, Userlogin } from "../../Utils/general-function";

import NoCars from "../../Utils/NoCars";
import Defaultpreview from "../../Utils/Defaultpreview";
import { useGearwiseCatalog } from "../../Contexts/GearwiseCatalogContext";

function GearwiseCatalog(props) {
  const [loading, setLoading] = useState(true);
  const [gearList, setGearList] = useState([]);
  const {
    carList,
    setCarList,
    setSelectedGearObj,
    selectedGearObj,
    setBranding,
    branding,
    countRef,
  } = useGearwiseCatalog();
  console.log("carList", carList);

  const navigate = useNavigate();
  // set 0 value for showing div for first page load
  const userid = localStorage.getItem("Ca1itd");
  const iphone = window.navigator.userAgent.includes("Mac");

  const fullUrl = new URL(
    "/#/gearwisecatalogshare/" +
      userid +
      "/" +
      selectedGearObj?.Value +
      "/" +
      branding,
    window.location.origin
  ).href; // sharing full url

  const fetchData = async () => {
    const res = await handleGetApiGF({ url: "/api/Common/Geardata" });
    console.log("gear res", res);
    if (!res?.succ) {
      Toast(false, "", res?.msg);
      setLoading(false);
      setGearList([]);
      return;
    }
    setGearList(res?.data?.Data || []);
    setLoading(false);
  };

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    fetchData();
  }, []);

  const handleDropchange = (obj) => {
    setSelectedGearObj(obj);
    Submit(obj.Value);
  };

  const Submit = (selectedmodel) => {
    let obj = new URLSearchParams({
      Randomid: userid,
      gearid: selectedmodel,
    }).toString();
    try {
      fetch(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/Carmaster/GetdetailsofCarsbyRandomidGearid?" +
          obj
      )
        .then((response) => response.json())
        .then((res) => {
          setCarList(res.Data || []);
          setLoading(false);
          countRef.current = 1;
        });
    } catch (error) {
      console.log(error);
    }
  };
  const Onchange = (e) => {
    setBranding(e.target.value);
  };
  return (
    <div className="page-space" style={{ marginBottom: "56px" }}>
      <Header />
      <div className="text-center">
        <h2 className="page-title">Gear Wise Catalog</h2>
      </div>
      {loading ? <Loader /> : null}
      {/*--------------- Search Module---------------------- */}
      <div className="search-div mt-2">
        <Select
          placeholder="Select Gear"
          name="gear"
          value={selectedGearObj}
          options={gearList}
          getOptionLabel={(option) => option.Text}
          getOptionValue={(option) => option.Value}
          onChange={(obj) => handleDropchange(obj, "gear")}
          closeMenuOnSelect={true}
          blurInputOnSelect={false}
          isSearchable={true}
          styles={{
            dropdownIndicator: (base, state) => ({
              ...base,
              transition: "transform 0.25s ease",
              transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
            }),
            control: (provided, state) => ({
              ...provided,
              border: "1px solid red",
              boxShadow: state.isFocused ? "red" : "red",
              "&:hover": {
                borderColor: "red",
              },
            }),
          }}
          className="w-100"
        ></Select>
        {/* <button className="add-citybtn" onClick={() => Submit()}>
            <span className="material-symbols-outlined">arrow_forward</span>
          </button> */}
      </div>
      {/* ------------------Share Module------------------ */}
      {countRef.current === 0 ? (
        <Defaultpreview
          img="assets/images/search.png"
          msg="Quickly find cars in your account by model. Share the list of selected models as a catalog seamlessly!!"
        />
      ) : (
        <>
          {carList.length === 0 ? (
            <NoCars />
          ) : (
            <>
              <div className="p-3">
                <div className="text-center">
                  <div class="form-div">
                    <div>
                      <div class="form-check-inline">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="radio1"
                          name="optradio"
                          value="Wh_B"
                          onChange={Onchange}
                          checked={branding === "Wh_B" ? true : false}
                        />
                        <label class="form-check-label px-1" for="radio1">
                          Share With Branding
                        </label>
                      </div>
                      <div class="form-check-inline">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="radio2"
                          name="optradio"
                          value="Wo_hB"
                          onChange={Onchange}
                          checked={branding === "Wo_hB" ? true : false}
                        />
                        <label class="form-check-label px-1" for="radio2">
                          Share Without Branding
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ---------------Result module--------------------- */}
              <Innerlistcommon
                catloguelist={carList}
                onDataChangeProp={
                  (obj) => setCarList(obj?.catloguelists || [])
                  // purpose: fire when unsold car from this catalogue
                }
                scrollKey="specifiedCatlogueScrollPosition"
                from="gearwisecatalog"
              />
              <div className="fixshare">
                <button
                  className="sharebtn"
                  onClick={(e) => {
                    iphone
                      ? shareIphonePostMsg({
                          action: "urlshare",
                          url: fullUrl,
                        })
                      : Shareurl(fullUrl);
                  }}
                >
                  Gear Wise Catalog
                  <span>
                    <img src="assets/images/share.png" alt="" />
                  </span>
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default GearwiseCatalog;
